export * from './checkScope';
